'use strict';
import Vue from 'vue';
import { AppFunctions } from '../functions/AppFunctions';
import { eventBus } from '../main';
import { router } from '../router';
import settings from '../settings';
import store from '../store';
import { AppStoreTypes } from '../store/modules/app';
import { timeout } from '../utils/common';
import { HttpContext } from '../utils/httpContext';
import { deleteToken, setToken } from '../utils/token';

class UserService {
  async GetProfil() {
    const url = settings.baseUrl + 'Api/User/GetProfil';
    const result = await HttpContext.post({ url });
    return result;
  }
  async GetUser() {
    const url = settings.baseUrl + 'Api/User/GetProfil';
    const result = await HttpContext.post({ url });
    store.dispatch(AppStoreTypes.user.set, { value: result });
    return result;
  }
  async SaveProfilModositasa({ form }) {
    const url = settings.baseUrl + 'Api/User/SaveProfilModositasa';
    const result = await HttpContext.post({ url, data: form });
    return result;
  }
  async Login({ email, password, projektId }) {
    const url = settings.baseUrl + 'Api/User/Login';
    let data = { Email: email, Password: password, ProjektId: projektId };
    const result = await HttpContext.post({ url, data });
    let token = result?.Token;
    if (token) {
      setToken(token);
      if (global.SNJS && global.SNJS.login) {
        global.SNJS.login(result.Id);
      }
    }
    await AppFunctions.GetInitData();
    eventBus.$emit('after-login');
    if (router.currentRoute.name != 'Fooldal') {
      router.push({ name: 'Fooldal' });
    }
    return result;
  }

  async Logout() {
    const url = settings.baseUrl + 'Api/User/Logout';
    var result = await HttpContext.post({ url });
    if (result?.Token) {
      setToken(result.Token);
    }
    if (global.SNJS && global.SNJS.logout) {
      global.SNJS.logout();
    }
    store.dispatch(AppStoreTypes.user.set, {
      value: { Id: -1, Name: 'nouser' },
    });
  }

  async ValidateToken(token) {
    const url = settings.baseUrl + 'Api/User/ValidateToken';
    var result = await HttpContext.post({ url, data: { token } });
    return result?.valid;
  }

  async Embed({ apiKey, isTokenSet }) {
    const url = settings.baseUrl + 'Api/User/Embed';
    var iframeurl = '';
    if (window == parent) {
      iframeurl = location.href;
    } else if (location.ancestorOrigins) {
      iframeurl = location.ancestorOrigins[0];
    } else {
      iframeurl = document.referrer;
    }
    settings.referrer = iframeurl;
    let data = { apiKey };
    const result = await HttpContext.post({
      url,
      data,
    });

    if (isTokenSet) {
      return true;
    }

    let token = result?.Token;
    if (token) {
      setToken(token);
      return true;
    }

    return false;
  }
  async FromUserGuid(guid) {
    const url = settings.baseUrl + 'Api/User/FromUserGuid';
    var iframeurl = '';
    if (window == parent) {
      iframeurl = location.href;
    } else if (location.ancestorOrigins) {
      iframeurl = location.ancestorOrigins[0];
    } else {
      iframeurl = document.referrer;
    }
    settings.referrer = iframeurl;
    let data = { guid };
    const result = await HttpContext.post({
      url,
      data,
    });

    let token = result?.Token;
    if (token) {
      setToken(token);
      return true;
    }

    return false;
  }
}

let instance = new UserService();
export { instance as userService };
global.BvHirek.services.userService = instance;
